module.exports = __webpack_public_path__ + "img/max-envelope-approve.5a34d6c7.svg";